module.exports = __webpack_public_path__ + "static/media/siren.3bcae03f.svg";